import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=3f790a78"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductPageDesktop: require('/opt/build/repo/components/product/page/Desktop.vue').default,ProductPageMobile: require('/opt/build/repo/components/product/page/Mobile.vue').default,SectionRelatedProducts: require('/opt/build/repo/components/section/RelatedProducts.vue').default,SectionOffers: require('/opt/build/repo/components/section/Offers.vue').default,LayoutBanner: require('/opt/build/repo/components/layout/Banner.vue').default})
